module.exports = __webpack_public_path__ + "img/Benefits_2.20d68a00.svg";